export const LOGIN_ACTION = "LOGIN_ACTION";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";

export const UPDATE_CART = "UPDATE_CART";
